import * as React from "react";
import { NavItem, NavLink } from "reactstrap"
import { IMenuItem } from "../types/IMenuItem";
import { ComfortableViewIcon, CompactViewIcon } from "./icons/customIcons/ViewPreferenceIcons";

export const VIEW_SETTINGS = {
    compactView: "compactView",
    comfortView: "comfortView"
}

const ViewPreferenceDropDown: React.FC<{ menuItem?: IMenuItem; isAccountMenu?: boolean; renderItemsOnly?: boolean }> = ({
    menuItem,
    isAccountMenu,
    renderItemsOnly
}) => {
    const [preferences, setPreferences] = React.useState(VIEW_SETTINGS.comfortView);

    React.useEffect(() => {
        const storedPreferences = localStorage.getItem('userPreferencesViewStyle');
        if (storedPreferences) {
            setPreferences(JSON.parse(storedPreferences));
            if (storedPreferences === `"${VIEW_SETTINGS.compactView}"` || storedPreferences === `${VIEW_SETTINGS.compactView}`) {
                document.body.classList.add('compactView');
            } else {
                document.body.classList.remove('compactView');
            }
        }
    }, []);

    const savePreferences = (updatedPreferences) => {
        localStorage.setItem('userPreferencesViewStyle', JSON.stringify(updatedPreferences));
        setPreferences(updatedPreferences);
        if (updatedPreferences === VIEW_SETTINGS.compactView) {
            document.body.classList.add('compactView');
        } else {
            document.body.classList.remove('compactView');
        }
    };

    const displayDropdownMenuItems = menuItem;

    if (!displayDropdownMenuItems) {
        return null;
    }

    const renderMenuItems = () => {
        return displayDropdownMenuItems.children.map((item) => {
            switch (item.name) {
                case 'comfortable':
                    return (
                        <NavItem key={VIEW_SETTINGS.comfortView}>
                            <NavLink onClick={() => savePreferences(VIEW_SETTINGS.comfortView)}>{preferences === VIEW_SETTINGS.comfortView ?
                                <>
                                    <ComfortableViewIcon />
                                    <b>{item.label}</b></> :
                                <>
                                    <ComfortableViewIcon />
                                    {item.label} </>}</NavLink>
                        </NavItem>
                    )
                case 'compact':
                    return (
                        <NavItem key={VIEW_SETTINGS.compactView}>
                            <NavLink onClick={() => savePreferences(VIEW_SETTINGS.compactView)} className="">

                                {preferences === VIEW_SETTINGS.compactView ?
                                    <>
                                        <CompactViewIcon />
                                        <b>{item.label}</b></> :
                                    <>
                                        <CompactViewIcon />{
                                            item.label} </>}

                            </NavLink>
                        </NavItem>
                    )
            }
        })
    };

    if (renderItemsOnly) {
        return (
            <ul className="mobileMenuSectionItems">
                {renderMenuItems()}
            </ul>
        )
    }

    if (isAccountMenu) {
        return (
            <>
                <NavItem className="userMenuSectionTitle" key={'viewPreference'}>
                    <h3>{displayDropdownMenuItems.label}</h3>
                </NavItem>
                <hr className="userMenuDivider" />
                {renderMenuItems()}
            </>
        )
    }

    return (
        <ul className="nav navbar-nav">
            <NavItem className="dropdown" key={'viewPreference'}>
                <NavLink className="dropdown-toggle">
                    {displayDropdownMenuItems.label}
                    <b className="caret"></b>
                </NavLink>
                <ul className="dropdown-menu" >
                    {renderMenuItems()}
                </ul>
            </NavItem >
        </ul>
    )
}

export default ViewPreferenceDropDown;